var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.266 17.798C17.225 15.683 19 12.97 19 10.182a7.277 7.277 0 0 0-2.058-5.086A6.91 6.91 0 0 0 12 3a6.91 6.91 0 0 0-4.942 2.096A7.277 7.277 0 0 0 5 10.182c0 2.788 1.775 5.501 3.734 7.616A26.283 26.283 0 0 0 12 20.76a26.288 26.288 0 0 0 3.266-2.963ZM12 22s8-5.454 8-11.818c0-2.17-.843-4.251-2.343-5.786A7.911 7.911 0 0 0 12 2a7.91 7.91 0 0 0-5.657 2.396A8.277 8.277 0 0 0 4 10.182C4 16.546 12 22 12 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.91c.9 0 1.667-.753 1.667-1.728S12.899 8.455 12 8.455c-.9 0-1.667.752-1.667 1.727 0 .975.768 1.727 1.667 1.727Zm2.667-1.728c0 1.506-1.194 2.727-2.667 2.727-1.473 0-2.667-1.22-2.667-2.727 0-1.506 1.194-2.727 2.667-2.727 1.473 0 2.667 1.22 2.667 2.727Z",
    fill: "currentColor"
  })));
};
export { SvgLocation as ReactComponent };
export default __webpack_public_path__ + "1c95ae69271e40f708970aefd38fd0d5.svg";